import { t } from "i18next";

export const FLOATING_BUTTON_POSITIONS = [
  {
    label: t("neetoMolecules.productEmbed.floatingPopup.position.bottomLeft"),
    value: "bottomLeft",
  },
  {
    label: t("neetoMolecules.productEmbed.floatingPopup.position.bottomRight"),
    value: "bottomRight",
  },
];

export const INITIAL_QUERY_PARAM = { name: "", value: "" };
